import { RegisterOptions } from "react-hook-form"

export const percentRules = (required: boolean): RegisterOptions => ({
  shouldUnregister: true,
  required: {
    value: required,
    message: "Required field",
  },
  validate: {
    max: (v: string) => parseInt(v || "0") <= 100 || "Max value exceeded",
  },
})
